import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 400px;
    border-left: 1px solid #444;
    background-color: #111;
`;

export const FullHeight = styled.div`
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 30px;
`;

export const Label = styled.div`
    width: 100%;
    padding: 0 0 5px;
    font-size: 12px;
    color: #999;
    text-transform: uppercase;
`;

export const Subtitle = styled.div`
    width: 100%;
    padding: 10px 0 15px;
    font-size: 16px;
    color: #888;
    line-height: 22px;
`;

export const EditableToValue = styled.div`
    width: 100%;
    height: 40px;
    line-height: 20px;
    padding: 0 0 5px;
    font-size: 12px;
    color: #fff;
`;

export const Input = styled.input`
    border: 1px solid #444;
    height: 30px;
    min-height: 30px;
    padding-left: 5px;
    width: 100%;
    color: #fff;
    background-color: #000;
    margin: 0 0 10px;

    &:focus {
        outline: none;
    }
`;

export const Select = styled.select`
    border: 1px solid #444;
    height: 30px;
    min-height: 30px;
    padding-left: 5px;
    width: 100%;
    color: #fff;
    background-color: #000;
    margin: 0 0 10px;

    &:focus {
        outline: none;
    }
`;

export const ImageName = styled.div`
    border: 1px solid #444;
    height: 30px;
    min-height: 30px;
    padding-left: 30px;
    position: relative;
    width: 100%;
    color: #fff;
    background-color: #000;
    margin: 0 0 10px;
    display: flex;
    font-size: 14px;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;

    &:before {
        font-family: 'Material Design Icons';
        font-size: 12px;
        color: #999;
        content: '\\F02E9';
        position: absolute;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        top: 0;
        left: 0;
        bottom: 0;
        width: 30px;
    }
`;

export const TextArea = styled.textarea`
    border: 1px solid #444;
    height: 90px;
    min-height: 90px;
    padding-left: 5px;
    width: 100%;
    color: #fff;
    background-color: #000;
    margin: 0 0 10px;

    &:focus {
        outline: none;
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    color: #fff;
`;

export const Button = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #aaa;
    height: 30px;
    width: 30px;
    background-color: #000;
    margin-right: -1px;
    border: 1px solid #666;
    padding-left: 30px;
    box-sizing: border-box;
    position: relative;
    transition: all .4s ease 0s;
    cursor: pointer;

    :hover {
        border-color: #fff;
        color: #fff;
        z-index: 2;
    }

    &.selected {
        border-color: #ddd;
        color:  #666;
        background-color: #ddd;
        z-index: 1;
    }

    :before {
        position: absolute;
        top: -1px;
        left: 0;
        width: 30px;
        height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        content: '${props => props.icon}';
        font-family: "Material Design Icons";
    }
`;

export const LabeledButtonGroup = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
`;

export const LabeledButton = styled.a`
    flex: 1;
    color: ${props => props.color || props.theme.colors.main};
    border: 1px solid ${props => props.color || props.theme.colors.main};
    height: 30px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: all .4s ease 0s;
    margin-left: 10px;

    &.fixedPadding {
        padding: 0 10px;
    }

    &.inactive {
        opacity: 0.4;
    }

    &:nth-child() {
        margin-left: 0;
    }

    &:not(.inactive):hover {
        cursor: pointer;
        color: #000;
        background-color: ${props => props.color || props.theme.colors.main};
    }
`;

export const Row = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: ${p => p.align || "center"};
    justify-content: ${p => p.justify || "stretch"};
    transition: background-color .4s ease 0s;

    &.highlight:hover {
        background-color: #333;
    }

    ${Label} {
        flex: 1;
        width: auto;
        min-width: 0;
        margin-left: 10px;

        &:first-child{
            margin-left: 0;
        }
    }

    ${Input} {
        flex: 1;
        width: auto;
        min-width: 0;
        margin-left: 10px;

        &:first-child{
            margin-left: 0;
        }
    }  
`;

const BaseButton = styled.div`
    height: 30px;
    width: 30px;
    min-width: 30px;
    margin: 0 5px;
    position: relative;
    transition: all .4s ease 0s;
    cursor: pointer;

    &:before {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 14px;
        font-family: "Material Design Icons";
        transition: all .4s ease 0s;
    }
`;

export const EditorAddButton = styled(BaseButton)`
    border: 1px solid #444;
    
    &:hover {
        background-color: #ccc;
    }

    &:before {
        content: '\\F048A';
    }

    &:hover:before {
        color: #000;
    }
`;

export const RemoveButton = styled(BaseButton)`
    border: 1px solid #f33;
    
    &:hover {
        background-color: #f33;
    }

    &:before {
        content: '\\F0A79';
        color: #f33;
    }

    &:hover:before {
        color: #fff;
    }
`;

export const EditorsList = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: stretch;
`;

export const EditorName = styled.div`
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    margin-left: 10px;
`;

export const RemoveEditorButton = styled(BaseButton)`
    border: 1px solid #f33;
    margin: 10px 10px 10px 0;
    
    &:hover {
        background-color: #f33;
    }

    &:before {
        color: #f33;
        content: '\\F0156';
    }
    
    &:hover:before {
        color: #fff;
    }
`;

export const NoEditors = styled.div`
    flex: 1;
    width: 100%;
    color: #666;
    text-align: center;
    padding: 100px 0 0;
    line-height: 25px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &:before {
        font-family: 'Material Design Icons';
        font-size: 150px;
        color: #333;
        content: '\\F0010';
        margin-bottom: 80px;
    }
`;

export const ConfirmMessage = styled.div`
    font-size: 16px;
    flex: 2;
    color: #fff;
`;